import Forms from "../services/Forms";

export default {

    props: ['formId','siteId', 'modalMessage', 'debug'],

    data: () => { return {
        messageStyle: 'none',
        isLoading: false,
        isSubmitted: false,
        error: null,
        response: {},
    }},

    mounted: function() {

    },

    methods: {
        onSubmit: function() {
            this.isLoading = true;
            this.scrollToMessage();

            this.response.siteid = this.siteId;

            Forms.Submit(this.formId, {response: this.response})
                .then((res) => {
                    this.isLoading = false;
                    if(this.modalMessage){
                        $('#modalMessageAfterSent' + this.formId).modal();
                    }else{
                        this.isSubmitted = true;
                        this.scrollToMessage();
                    }
                })
                .catch((err) => {
                    this.isLoading = false;
                    this.isSubmitted = false;
                    this.error = err;
                    this.scrollToMessage();
                })
        },
        scrollToMessage: function() {
            this.messageStyle = 'block';
            document.querySelector('#messages-' + this.formId)
                .scrollIntoView(
                    {
                        behavior: 'smooth'
                    });
        }
    }

}
